var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.715V26.85L36.555 24.75C35.385 23.745 33.495 23.745 32.325 24.75L26.085 30.105C24.915 31.11 23.025 31.11 21.855 30.105L21.345 29.685C20.28 28.755 18.585 28.665 17.385 29.475L10.005 34.425L9.84 34.545C9.285 33.345 9 31.92 9 30.285V17.715C9 12.255 12.255 9 17.715 9H30.285C35.745 9 39 12.255 39 17.715Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 21.5697C21.4718 21.5697 23.0702 19.9713 23.0702 17.9997C23.0702 16.028 21.4718 14.4297 19.5002 14.4297C17.5285 14.4297 15.9302 16.028 15.9302 17.9997C15.9302 19.9713 17.5285 21.5697 19.5002 21.5697Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9998 26.8498V30.2848C38.9998 35.7448 35.7448 38.9998 30.2848 38.9998H17.7148C13.8898 38.9998 11.1298 37.3948 9.83984 34.5448L10.0048 34.4248L17.3848 29.4748C18.5848 28.6648 20.2798 28.7548 21.3448 29.6848L21.8548 30.1048C23.0248 31.1098 24.9148 31.1098 26.0848 30.1048L32.3248 24.7498C33.4948 23.7448 35.3848 23.7448 36.5548 24.7498L38.9998 26.8498Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.06a0a063169e89bb95e752ed50281b7d.svg";
export { ForwardRef as ReactComponent };